enum Mutations {
  DATASET_SET = 'dataset-set',
  FORCED_VALUES_SET = 'forced-values-set',
  DEFAULT_VALUES_SET = 'defaults-values-set',
  PROXIED_VALUES_SET = 'dataset-set-proxied',
  TEMPLATE_SET = 'template-set',
  UPDATE_SWITCH_CHANGE = 'update-switch-change',

  SITES_SET = 'sites-set',
  PAGENO_SET = 'PAGENO_SET',
  SITENO_SET = 'SITENO_SET',
}

export default Mutations;
